export default "__VITE_ASSET__C2Qoef9D__"